import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './DadosCNPJ.css';

// API base URL based on environment
const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? process.env.REACT_APP_VERCEL_API_URL || 'https://api.veridicus.com.br'
  : process.env.REACT_APP_LOCAL_API_URL || 'http://localhost:5000';

const DadosCNPJ = ({ clienteId }) => {
  const [cnpjInfo, setCnpjInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCNPJInfo = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token');
        
        if (!token) {
          throw new Error('Token de autenticação não encontrado');
        }
        
        const response = await axios.get(`${API_BASE_URL}/api/clientes/${clienteId}/cnpj-info`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        setCnpjInfo(response.data.data);
        setLoading(false);
      } catch (err) {
        console.error('Erro ao buscar informações do CNPJ:', err);
        setError(err.response?.data?.message || err.message || 'Erro ao buscar informações do CNPJ');
        setLoading(false);
      }
    };

    if (clienteId) {
      fetchCNPJInfo();
    }
  }, [clienteId]);

      if (loading) {
        return (
          <div className="loading-indicator">
            <div className="spinner"></div>
            <span>Carregando informações do CNPJ...</span>
          </div>
        );
      }
      
      if (error) {
        return (
          <div className="error-message">
            <i className="fas fa-exclamation-triangle"></i>
            Erro: {error}
          </div>
        );
      }
      
      if (!cnpjInfo) {
        return (
          <div className="info-message">
            <i className="fas fa-info-circle"></i>
            Nenhuma informação de CNPJ disponível para este cliente.
          </div>
        );
      }

  return (
    <div className="dados-cnpj-container">
      <div className="dados-cnpj-section">
        <h3>
          <i className="fas fa-id-card"></i>
          Dados do CNPJ
        </h3>
        <div className="dados-cnpj-grid">
          <div className="dados-cnpj-item">
            <span className="dados-cnpj-label">CNPJ:</span>
            <span className="dados-cnpj-value">{cnpjInfo.taxId}</span>
          </div>
          
          {cnpjInfo.alias && (
            <div className="dados-cnpj-item">
              <span className="dados-cnpj-label">Nome Fantasia:</span>
              <span className="dados-cnpj-value">{cnpjInfo.alias}</span>
            </div>
          )}
          
          {cnpjInfo.updated && (
            <div className="dados-cnpj-item">
              <span className="dados-cnpj-label">Atualizado em:</span>
              <span className="dados-cnpj-value">
                {new Date(cnpjInfo.updated).toLocaleDateString('pt-BR')}
              </span>
            </div>
          )}
          
          {cnpjInfo.founded && (
            <div className="dados-cnpj-item">
              <span className="dados-cnpj-label">Data de Fundação:</span>
              <span className="dados-cnpj-value">
                {new Date(cnpjInfo.founded).toLocaleDateString('pt-BR')}
              </span>
            </div>
          )}
          
          {cnpjInfo.status && (
            <div className="dados-cnpj-item">
              <span className="dados-cnpj-label">Status:</span>
              <span className="dados-cnpj-value">
                {cnpjInfo.status.text}
              </span>
            </div>
          )}
        </div>
      </div>

      {cnpjInfo.company && (
        <div className="dados-cnpj-section">
          <h3>
          <i className="fas fa-briefcase"></i>
          Dados da Empresa
        </h3>
          <div className="dados-cnpj-grid">
            {cnpjInfo.company.name && (
              <div className="dados-cnpj-item">
                <span className="dados-cnpj-label">Nome:</span>
                <span className="dados-cnpj-value">{cnpjInfo.company.name}</span>
              </div>
            )}
            
            {cnpjInfo.company.nature && (
              <div className="dados-cnpj-item">
                <span className="dados-cnpj-label">Natureza Jurídica:</span>
                <span className="dados-cnpj-value">{cnpjInfo.company.nature.text}</span>
              </div>
            )}
            
            {cnpjInfo.company.size && (
              <div className="dados-cnpj-item">
                <span className="dados-cnpj-label">Porte:</span>
                <span className="dados-cnpj-value">{cnpjInfo.company.size.text}</span>
              </div>
            )}
            
            {cnpjInfo.company.equity !== undefined && (
              <div className="dados-cnpj-item">
                <span className="dados-cnpj-label">Capital Social:</span>
                <span className="dados-cnpj-value">
                  {cnpjInfo.company.equity.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                  })}
                </span>
              </div>
            )}
          </div>
        </div>
      )}
      
      {cnpjInfo.address && (
        <div className="dados-cnpj-section">
          <h3>
          <i className="fas fa-map-marked-alt"></i>
          Endereço
        </h3>
          <div className="dados-cnpj-grid">
            {cnpjInfo.address.street && (
              <div className="dados-cnpj-item">
                <span className="dados-cnpj-label">Logradouro:</span>
                <span className="dados-cnpj-value">
                  {cnpjInfo.address.street}
                  {cnpjInfo.address.number && `, ${cnpjInfo.address.number}`}
                  {cnpjInfo.address.details && ` - ${cnpjInfo.address.details}`}
                </span>
              </div>
            )}
            
            {cnpjInfo.address.district && (
              <div className="dados-cnpj-item">
                <span className="dados-cnpj-label">Bairro:</span>
                <span className="dados-cnpj-value">{cnpjInfo.address.district}</span>
              </div>
            )}
            
            {cnpjInfo.address.city && (
              <div className="dados-cnpj-item">
                <span className="dados-cnpj-label">Cidade:</span>
                <span className="dados-cnpj-value">{cnpjInfo.address.city}</span>
              </div>
            )}
            
            {cnpjInfo.address.state && (
              <div className="dados-cnpj-item">
                <span className="dados-cnpj-label">Estado:</span>
                <span className="dados-cnpj-value">{cnpjInfo.address.state}</span>
              </div>
            )}
            
            {cnpjInfo.address.zip && (
              <div className="dados-cnpj-item">
                <span className="dados-cnpj-label">CEP:</span>
                <span className="dados-cnpj-value">{cnpjInfo.address.zip}</span>
              </div>
            )}
          </div>
        </div>
      )}
      
      {cnpjInfo.mainActivity && (
        <div className="dados-cnpj-section">
          <h3>
          <i className="fas fa-industry"></i>
          Atividade Principal
        </h3>
          <div className="dados-cnpj-grid">
            <div className="dados-cnpj-item">
              <span className="dados-cnpj-label">Código:</span>
              <span className="dados-cnpj-value">{cnpjInfo.mainActivity.id}</span>
            </div>
            <div className="dados-cnpj-item">
              <span className="dados-cnpj-label">Descrição:</span>
              <span className="dados-cnpj-value">{cnpjInfo.mainActivity.text}</span>
            </div>
          </div>
        </div>
      )}
      
      {cnpjInfo.sideActivities && cnpjInfo.sideActivities.length > 0 && (
        <div className="dados-cnpj-section">
          <h3>
          <i className="fas fa-project-diagram"></i>
          Atividades Secundárias
        </h3>
          <div className="dados-cnpj-side-activities">
            {cnpjInfo.sideActivities.map((activity, index) => (
              <div key={index} className="dados-cnpj-side-activity">
                <strong>{activity.id}</strong>: {activity.text}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default DadosCNPJ;